var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6867 9.84656C1.54493 10.7759 2.17875 11.421 2.95478 11.7424C5.92996 12.975 10.0702 12.975 13.0453 11.7424C13.8214 11.421 14.4552 10.7759 14.3135 9.84656C14.2263 9.27543 13.7955 8.79983 13.4763 8.33543C13.0583 7.7197 13.0167 7.04803 13.0167 6.3335C13.0167 3.57207 10.7707 1.3335 8.00008 1.3335C5.2295 1.3335 2.9835 3.57207 2.9835 6.3335C2.98344 7.04803 2.9419 7.7197 2.52382 8.33543C2.20464 8.79983 1.77382 9.27543 1.6867 9.84656Z",
    stroke: "#818183",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 12.6665C5.63891 13.8166 6.71692 14.6665 7.99992 14.6665C9.28292 14.6665 10.3609 13.8166 10.6666 12.6665",
    stroke: "#818183",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.062e1859208432d4a8ade81405f9f1bd.svg";
export { ForwardRef as ReactComponent };